import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full h-[380px] md:h-[480px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20street%20style%20scene%20with%20pair%20of%20cream%20sneakers%20and%20leather%20accessories%20on%20clean%20sand%20colored%20concrete%20floor%2C%20soft%20golden%20hour%20sunlight%20casting%20long%20shadows%2C%20editorial%20lifestyle%20photography%2C%20warm%20amber%20tones%2C%20elegant%20simple%20composition%2C%20peaceful%20urban%20aesthetic&width=1800&height=960&seq=cta-bg-v3&orientation=landscape"
        alt="Sugargoo shopping"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/70 via-foreground-900/40 to-foreground-900/20"></div>

      <div className="relative w-full h-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto h-full flex flex-col justify-between py-12 md:py-16">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 uppercase tracking-wide">
            Ready to Shop?
          </h2>

          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 bg-background-50 text-foreground-900 rounded-full px-8 py-4 text-sm md:text-base font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer w-fit"
            >
              Browse Full Spreadsheet
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-900">
                <i className="ri-arrow-right-line text-background-50 text-sm"></i>
              </span>
            </a>

            <p className="text-sm md:text-base text-background-50/80 leading-relaxed max-w-xs md:text-right">
              Verified links. Real QC photos.<br />
              Updated daily for 2026.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}